import { IUpdateMotivoDemissaoUseCase } from "../../../presentation/useCases/update/update_motivo_demissao_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateMotivoDemissaoUseCase
 */

export class UpdateMotivoDemissaoUseCase implements IUpdateMotivoDemissaoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async updateMotivoDemissao(
    idMotivoDemissao: number,
    ativo: number,
    descricaoMotivo: string,
  ): Promise<void> {
    await this.repository.updateMotivoDemissao(
      idMotivoDemissao,
      ativo === 1,
      descricaoMotivo,
    );
  }
}